import { formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

export interface SessionConflictDetails {
  city: string | null;
  country: string | null;
  lastActivityAt: string;
}

export interface SessionConflictResponse {
  error: 'session_conflict';
  message: string;
  session: SessionConflictDetails;
  replaceToken: string;
}

export function isSessionConflict(error: unknown): error is HttpErrorResponse & { error: SessionConflictResponse } {
  return error instanceof HttpErrorResponse && error.status === 409 && error.error?.error === 'session_conflict';
}

const HTML_ENTITIES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function buildSessionConflictContent({ city, country, lastActivityAt }: SessionConflictDetails): string {
  const location = [city, country]
    .filter(Boolean)
    .join(', ')
    .replace(/[&<>"']/g, character => HTML_ENTITIES[character]);
  const lastActivity = `last activity ${formatDate(lastActivityAt, 'MM/dd/yyyy HH:mm', 'en-US')}`;
  const details = location ? `${location}, ${lastActivity}` : lastActivity;
  return `Another session is already active on this account (${details}). Continue here and end that session?`;
}
